import { APP_ID_ADS } from "constant/application";
import {
  fetchAdDeliverReportAction,
  unloadAdDeliveryReportAction,
} from "fleet/redux-store/ui-state/ad-delivery-report/actions";
import { adDeliveryReportSelector } from "fleet/redux-store/ui-state/ad-delivery-report/selectors";
import { AdDeliveryReportPage } from "fleet/view/report/ad-delivery";
import { connect } from "react-redux";
import {
  applicationsSelector,
  getByApplicationName,
} from "redux-store/applications/selectors";
import { deviceWithStatusSelector } from "redux-store/derivative-selectors";
import { networksSelector } from "redux-store/networks/selectors";
import { makeGetAllAsArray, makeGetSelectOptions } from "redux-store/selectors";
import { storesReady } from "redux-store/utils";

const getAppsAsArray = makeGetAllAsArray();
const getNetworksAsArray = makeGetAllAsArray();
const getNetworkSelectOptions = makeGetSelectOptions();

function mapStateToProps(state) {
  const storesLoaded = storesReady(
    state.global.applications,
    state.global.devices,
    state.global.networks,
  );
  const appById = applicationsSelector(state);
  const applications = getAppsAsArray({ byId: appById });
  const adsApp = getByApplicationName(applications, APP_ID_ADS);
  const devices = deviceWithStatusSelector(state);
  const networkById = networksSelector(state);
  const networks = getNetworksAsArray({ byId: networkById });
  const networkOptions = getNetworkSelectOptions(networkById);
  const report = adDeliveryReportSelector(state);

  return {
    adsApp,
    devices,
    networks,
    networkOptions,
    report,
    storesLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAdDeliveryReport: (serviceArgs) => {
      return new Promise((resolve, reject) => {
        dispatch(
          fetchAdDeliverReportAction({
            reject,
            resolve,
            serviceArgs,
          }),
        );
      });
    },

    unloadAdDeliveryReport: () => {
      return dispatch(unloadAdDeliveryReportAction);
    },
  };
}

const ConnectedAdDeliveryReportPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdDeliveryReportPage);

export { ConnectedAdDeliveryReportPage };
